/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxCategory } from '../../models/tax-category';

export interface TaxCategoriesTaxCategoryIdGet$Params {
  'Active-Tenant-Identifier': string;
  taxCategoryId: string;
}

export function taxCategoriesTaxCategoryIdGet(http: HttpClient, rootUrl: string, params: TaxCategoriesTaxCategoryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesTaxCategoryIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('taxCategoryId', params.taxCategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategory>;
    })
  );
}

taxCategoriesTaxCategoryIdGet.PATH = '/tax-categories/{taxCategoryId}';
